module.exports = __webpack_public_path__ + "img/new-xrpintel-features.1d8e458c.png";